import React from "react";
import img1 from "./assests/imgs/cmp1.jpg";
import img2 from "./assests/imgs/cmp2.jpg";
import img3 from "./assests/imgs/cmp3.jpg";
import img4 from "./assests/imgs/cmp4.png";
import img5 from "./assests/imgs/cmp5.jpg";
export default function Companies() {
  return (
    <section className="section" id="blog">
      <div className="container text-center">
        <h6 className="section-title mb-6">Work History</h6>
        <div className="blog-card">
          <div className="blog-card-body">
            <h5 className="blog-card-title">Software Developer</h5>
            <h5 className="blog-card-title" style={{ color: "black" }}>
              Opop Media
            </h5>
            <h5 className="blog-card-title" style={{ color: "black" }}>
              Manchester,United Kingdom
            </h5>
            <p className="blog-card-caption">
              <b style={{ fontWeight: "bold" }}>Date: January 2023-Present</b>
              <br></br>
              <b className="blog-card-title" style={{ fontWeight: "bold" }}>
                Technologies Used: Laravel, MySQL, Plesk, GitHub,Nginx,Node.js,
                <br></br>React.js,Cypress,AWS,Pipedrive
              </b>
            </p>
            <p>
              I worked as a Full Stack Developer at Opop Media, focusing on web
              development with Laravel, Node.js, and React.js, enabling me to
              work on both frontend and backend tasks. I integrated APIs to
              ensure smooth communication between system components, drawing on
              my knowledge of RESTful architecture and HTTP protocols.
            </p>
            <br></br>
            <p>
              In addition, I used AWS services like CloudWatch, Elastic
              Beanstalk, and EC2 to monitor performance, deploy scalable
              applications, and manage server instances, enhancing deployment
              and infrastructure reliability.I also used Cypress for automated
              end-to-end testing to ensure code quality and functionality.
            </p>
            <br></br>{" "}
            <p>
              My experience at Opop Media gave me a well-rounded skill set for
              building efficient, scalable web applications
            </p>{" "}
          </div>
        </div>
        <div className="blog-card">
          <div className="blog-card-body">
            <h5 className="blog-card-title">Backend Development Team Lead</h5>
            <h5 className="blog-card-title" style={{ color: "black" }}>
              Cocoalabs India Pvt Ltd
            </h5>
            <h5 className="blog-card-title" style={{ color: "black" }}>
              Kerala, India
            </h5>
            <p className="blog-card-caption">
              <b style={{ fontWeight: "bold" }}>
                {" "}
                Date: December 2021 - June 2022
              </b>
              <br></br>
              <b className="blog-card-title" style={{ fontWeight: "bold" }}>
                Technologies Used: Yii2, Laravel, MySQL, Plesk, GitHub, Apache,
                Paytm, Decentro
              </b>
            </p>

            <p>
              I developed more than two new software solutions by analyzing
              system performance standards, leading to significant improvements
              in functionality. My work included integrating leading banking
              platforms such as Decentro, Razorpay, and Paytm to enhance payment
              processing capabilities.
            </p>
            <br></br>

            <p>
              I upgraded existing software, making valuable modifications to
              improve system performance and user experience. Additionally, I
              created and executed over 50 test procedures for various software
              components, ensuring a high level of quality and reliability.
            </p>
            <br></br>

            <p>
              My role involved analyzing more than 50 user requirements to
              derive technical software designs and performance specifications.
              I also planned, tracked, and managed deliverables across 8+
              short-term sprints and 2+ long-term deployments, successfully
              meeting project timelines and quality standards.
            </p>
          </div>
        </div>
        <div className="blog-card">
          <div className="blog-card-body">
            <h5 className="blog-card-title">Senior Software Engineer</h5>
            <h5 className="blog-card-title" style={{ color: "black" }}>
              Buyuk Software Solutions Pvt Ltd
            </h5>
            <h5 className="blog-card-title" style={{ color: "black" }}>
              Kerala,India
            </h5>
            <p className="blog-card-caption">
              <b style={{ fontWeight: "bold" }}>
                {" "}
                Date: November 2020 - November 2021
              </b>
              <br></br>
              <b style={{ fontWeight: "bold" }}>
                Technologies Used:
                Vue.js,Laravel,MySQL,AWS,PostgreSQL,GitLab,GitHub,Nginx,Apache
              </b>
            </p>

            <p>
              I led the development of a new School ERP Software designed for
              over 100,000 users. This involved architecting and implementing
              the system using Laravel and Vue.js, ensuring a robust and
              scalable solution. I also managed and maintained an existing ERP
              Software system, focusing on stability and performance.
            </p>
            <br></br>

            <p>
              Part of my role included integrating and enhancing existing
              software systems to increase their utility and value to the
              organization. As the team lead, I coordinated a group of four
              developers, promoting cohesion and efficiency throughout the
              development process, ensuring that project milestones were met and
              quality standards were maintained
            </p>
          </div>
        </div>
        <div className="blog-card">
          <div className="blog-card-body">
            <h5 className="blog-card-title">Associate Software Engineer</h5>
            <h5 className="blog-card-title" style={{ color: "black" }}>
              C Square Info Solutions Pvt. Ltd
            </h5>
            <h5 className="blog-card-title" style={{ color: "black" }}>
              Kerala, India
            </h5>
            <p className="blog-card-caption">
              <b style={{ fontWeight: "bold" }}>
                {" "}
                Date: September 2018 -February 2020
              </b>
              <br></br>
              <b className="blog-card-title" style={{ fontWeight: "bold" }}>
                Technologies Used: Yii2, Laravel, MySQL, GitHub, Apache
              </b>
            </p>

            <p>
              I collaborated with a fellow developer to deploy RESTful APIs in
              PHP, contributing to enhanced system functionality. This required
              close coordination with project teams, ensuring smooth progress
              and on-time delivery. I adhered to precise software designs,
              developing code that aligned with the defined project objectives.
            </p>
            <br></br>

            <p>
              In my work, I strictly followed established software development
              processes and best practices to achieve optimal results. I also
              maintained thorough documentation of test procedures, which helped
              in tracking progress and resolving project-related issues. This
              approach ensured the integrity of the project and contributed to
              efficient and reliable software development.
            </p>
          </div>
        </div>
        <div className="blog-card">
          <div className="blog-card-body">
            <h5 className="blog-card-title">PHP Developer</h5>
            <h5 className="blog-card-title" style={{ color: "black" }}>
              Libratech Solutions
            </h5>
            <h5 className="blog-card-title" style={{ color: "black" }}>
              Kerala, India
            </h5>
            <p className="blog-card-caption">
              <b style={{ fontWeight: "bold" }}>
                {" "}
                Date: August 2017 - February 2018
              </b>
              <br></br>
              <b className="blog-card-title" style={{ fontWeight: "bold" }}>
                Technologies Used: PHP, MySQL, GitHub, Apache
              </b>
            </p>

            <p>
              I integrated robust data storage solutions into web applications,
              ensuring seamless performance and reliability. I promptly
              addressed integration requests from front-end developers,
              facilitating smooth functionality and user experience.
            </p>
            <br></br>

            <p>
              I conducted comprehensive testing on back-end features to
              guarantee optimal performance, utilizing a range of testing
              methodologies. My role also involved troubleshooting, where I
              quickly identified and resolved application issues to maintain
              system stability.
            </p>
            <br></br>

            <p>
              Additionally, I developed efficient PHP modules and back-end code
              to enhance application performance. This work contributed to a
              more scalable and robust application architecture, ultimately
              delivering a better experience for end users.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
